import { addDoc, collection } from "firebase/firestore";
import { TRACKING_ACTION, TRACKING_ACTION_FAILURE, TRACKING_ACTION_SUCCESS } from "./Types";
import { db, auth } from "../App";



///////////////////// TRACKING ////////////////////////////////////////////////////////////////////


export const newTracking = (type, description, status = 'initiated', metadata = {}) => {
    // type: Type of the tracking action (e.g., 'user', 'paymentRecord', 'feeRecord', etc.).
    // time: Timestamp of the tracking action.
    // description: Description of the tracking action.
    // userID: ID of the user performing or associated with the action.
    // status: Status of the tracking action (e.g., 'initiated', 'completed', 'failed').
    // metadata: Additional information related to the tracking action.
    return async (dispatch) => {
      // Dispatching initiation action
      dispatch({
        type: TRACKING_ACTION,
      });
  
      try {
        // Reference to the tracking collection
        const trackingCollectionRef = collection(db, 'tracking');
  
        // Creating a new tracking document
        const newTrackingDoc = {
          // trackingID: uuidv4(),  // Generating a unique ID for the tracking action
          type,
          time: Date.now(),
          description,
          userID: auth.currentUser.uid,
          status,
          metadata,
        };
  
        // Adding the new tracking document to the collection
        await addDoc(trackingCollectionRef, newTrackingDoc);
  
        // Dispatching success action
        dispatch({
          type: TRACKING_ACTION_SUCCESS,
          payload: newTrackingDoc,
        });
  
      } catch (error) {
        // console.error('Error creating new tracking action:', error);
  
        // Dispatching failure action
        dispatch({
          type: TRACKING_ACTION_FAILURE,
          payload: error.message,
        });
      }
    };
  };
  